import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { DoctorReferralService } from '../../../../services/doctor-referral.service';
import { Title } from '@angular/platform-browser';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from '../../../../models/PromiseResult';
import {
    ReferralDoctorsModel,
    getDoctorReferal
} from '../../../../models/Doctorreferral';
import { DoctorReferraProfileView, languages, doctor_certificates } from '../../../../models/Doctorprofile';
import { MessageService } from 'primeng/api';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
    other_medical_egd
} from '../../../../models/othermedic';
import { DEFUALT_DOCTOR_IMAGE, URLS } from 'src/app/constant/constant';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-approvals',
    templateUrl: './approvals.component.html',
    styleUrls: ['../../../../../assets/css/custom-egd.css'],
    encapsulation: ViewEncapsulation.None
})
export class ApprovalsComponent implements OnInit {
    confirmDialogVisible = false;
    current_user_guid: string = sessionStorage.getItem('userid');
    PendingDoctors: ReferralDoctorsModel[] = [];
    ErrorMessage: string = null;
    doctorProfile: DoctorReferraProfileView;
    otherMedicalProfile: other_medical_egd = null;
    DoctorProfileDialogVisible: boolean = false;
    displayViewResume: boolean = false;
    resume_url: string = '';
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    loading: boolean;
    getDoctorReferalData: getDoctorReferal;
    current_doctor_userid: string = null;
    is_uk_country: boolean = false;
    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;
    is_doctor: boolean = true;
    slug: string = "";
    langs: languages[] = [];
    certs: doctor_certificates[] = [];
    defualt_doctor_image: string = DEFUALT_DOCTOR_IMAGE;
    readonly medics = {
        doctor: 'Doctor',
        other_medic: 'Other Medical Professionals'
    };
    readonly displayedColumns: string[] = [
        'created_at',
        'request_sent_date',
        'profession_type',
        'doctor_referred_name',
        'name',
        'specialty_name',
        'name',
        'country_name',
        'state_name',
        'Doctoremail',
        'status'
    ];

    constructor(
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly doctorReferralService: DoctorReferralService,
        private readonly messageService: MessageService,
        private readonly utilitiesService: UtilitiesService,
        private readonly titleService: Title,
        private readonly providerstateService: ProviderStateService,
        private readonly http: HttpClient
    ) {

        this.posting = false;
        this.loading = false;
    }

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Pending/Approvals");
        this.slug = this.providerstateService.getProviderSlug();
        if (URLS.IS_UK) {
            this.is_uk_country = true
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Doctor Registration' },
            { label: 'Pending/Approvals' }
        ]);
        this.posting = false;
        this.current_doctor_userid = sessionStorage.getItem('userid');
        this.getDoctorReferalData = {
            current_user_guid: this.current_doctor_userid,
            user_guid: null,
            profession_type: null
        };
        await this.ResetResultModels();
        await this.ResetResultTableModels();
        await this.GetPendingRequests();
    }
    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    private async ResetResultTableModels(): Promise<void> {
        this.table_response = {
            success: null,
            error: null,
            data: null
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    async DoAction(action_id: number, user_guid: string) {
        await this.ResetResultModels();
        this.posting = true;
        await this.doctorReferralService
            .UpdatestatusDoctorReferrals(
                action_id,
                user_guid
            )
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    let detail = '';
                    if (action_id == 1) detail = 'Request sent';
                    else if (action_id == 2) detail = 'Doctor Approved';
                    else detail = 'Doctor Declined';
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: detail
                    });
                } else if (!this.response.success) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        sticky: true,
                        detail: result.error.code + ' : ' + result.error.message
                    });
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
        this.GetPendingRequests();
    }

    async getDoctorProfilesData(user_guid: string, profession_type: string) {
        this.posting = true;
        this.getDoctorReferalData = {
            current_user_guid: this.current_doctor_userid,
            user_guid: user_guid,
            profession_type: profession_type
        };

        await this.ResetResultModels();
        // this.posting = true;
        this.DoctorProfileDialogVisible = true;
        await this.doctorReferralService
            .getReferralDoctorsProfile(this.getDoctorReferalData)
            .toPromise()
            .then((result) => {
                this.response = result;
                if (this.response.success) {
                    // this.doctorProfile.pop();
                    this.doctorProfile = null;
                    this.otherMedicalProfile = null;
                    if (profession_type == 'doctor') {
                        this.doctorProfile = result.data.doctor;
                        this.resume_url =
                            this.doctorProfile.doctor_profile.resume_url;
                        this.is_doctor = true;
                        this.langs = result.data.languages;
                        this.certs = result.data.doctor.doctor_certificates;
                        console.log(this.certs, "HEyyyyy");
                    } else {

                        this.otherMedicalProfile = result.data.doctor;
                        this.resume_url =
                            this.otherMedicalProfile.other_medical_profile.resume_url;
                        this.is_doctor = false;
                        this.langs = result.data.languages;

                    }

                    this.posting = false;
                } else if (!this.response.success) {
                    this.error.message = result.error.message;
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
    }

    async GetPendingRequests() {
        await this.ResetResultTableModels();
        this.loading = true;
        await this.doctorReferralService
            .getPendingDoctorReferrals()
            .toPromise()
            .then((result) => {
                this.response = result;
                this.PendingDoctors = [];
                if (this.response.success) {
                    // this.PendingDoctors=result.data;
                    let temp = [];
                    for (let i = 0; i < result.data.length; i++) {
                        let transaction_obj = {
                            created_at: result.data[i].created_at,
                            request_sent_date: result.data[i].request_sent_date,
                            doctor_referred_name:
                                result.data[i].doctor_referred_name == null
                                    ? 'N/A'
                                    : result.data[i].doctor_referred_name,
                            name: result.data[i].name,
                            specialty_name:
                                result.data[i].d_specialty_type?.specialty_name,
                            country_name: result.data[i].country?.country_name,
                            state_name: result.data[i].state_name,
                            Doctoremail: result.data[i].d_email,
                            status: result.data[i].status,
                            doctor_guid: result.data[i].doctor_guid,
                            user_guid: result.data[i].user_guid,
                            profession_type: result.data[i].profession_type
                        };
                        temp.push(transaction_obj);
                    }
                    this.PendingDoctors = temp;
                } else if (!this.response.success) {
                    this.error.message = result.error.message;
                }

                this.loading = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
    }

    async CloseReferralView(): Promise<void> {
        this.DoctorProfileDialogVisible = false;
        this.doctorProfile = null;
    }

    view_resume() {
        this.displayViewResume = true;
    }

    close_resume() {
        this.displayViewResume = false;
    }

    getImageUrl(defualt_url: string, original_url: string): string {
        return this.utilitiesService.getImageUrl(defualt_url, original_url);
    }
    downloadBase64PDF(apiUrl: string, fallbackFilename: string): void {
        this.http.get(apiUrl).subscribe((res: any) => {
            if (res?.data?.base64) {
                const base64 = res.data.base64;
                const filename = res.data.filename || fallbackFilename || 'document.pdf';
                const mimeType = res.data.mime_type || 'application/pdf';

                const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;
                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mimeType });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error('Invalid base64 response');
            }
        });
    }

}
